import React from "react";
import "../assets/css/InBody.scss";
import logo from "../assets/img/InBody-logo.png";

const Error404 = () => {
  return (
    <>
      <div className="panel-container">
        <div className="panel">
          <div className="logo-container">
            <img src={logo} alt="InBodyLogo" height="25px" />
          </div>
          <div className="halo-gradient"></div>
          <div className="background-image"></div>
          <div className="panel-inner">
            <h1>Page Not Found</h1>
            <p>The page you're trying to reach does not exist.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error404;
